export default __webpack_public_path__ + "static/logo-d65a506b0acb6b557e29913c80bbf24a.svg";